<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('priorities')"
      :columns="columns"
      :column_search="true"
      :extra_buttons="extra_buttons"
      :page_length="25"
      resource_url="/helpdesk/priority/datatables"
    ></generic-table>
  </div>

  <priority-modal ref="priority_modal" @success="refresh" />
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  error_message,
} from "@/utils";
import PriorityModal from "./priority_modal/Index.vue";

export default {
  name: "PrioritiesDatatable",
  components: { GenericTable, PriorityModal },
  data() {
    let v = this;
    return {
      extra_buttons: [
        {
          text: v.$t("add_priority"),
          icon: "fa fa-plus",
          class: "is-primary is-rounded",
          click: this.create,
        },
      ],
      columns: [
        {
          title: v.$t("name"),
          name: "name",
          searchable: true,
          data: (row) => {
            const colorStyle = row.color
              ? `background-color: ${row.color}; color: white;`
              : "";
            const iconClass = this.get_priority_icon(row.name);

            return `<div class="media">
              <div class="media-left">
                <span class="tag" style="${colorStyle}">
                  <i class="fa ${iconClass}"></i>
                </span>
              </div>
              <div class="media-content">
                <div class="content">
                  <p class="title is-6 mb-1">${row.name || ""}</p>
                  <p class="subtitle is-7 has-text-grey">${
                    row.description || ""
                  }</p>
                </div>
              </div>
            </div>`;
          },
        },
        {
          title: v.$t("sla_hours"),
          searchable: false,
          data: (row) => {
            if (row.sla_hours) {
              const urgencyClass =
                row.sla_hours <= 4
                  ? "is-danger"
                  : row.sla_hours <= 24
                  ? "is-warning"
                  : "is-info";
              return `<span class="tag ${urgencyClass}">${row.sla_hours}h</span>`;
            }
            return "";
          },
        },
        {
          title: v.$t("escalation"),
          searchable: false,
          data: (row) => {
            if (row.escalation_hours) {
              return `<span class="tag is-warning">${row.escalation_hours}h</span>`;
            }
            return `<span class="tag is-light">${v.$t("no_escalation")}</span>`;
          },
        },
        {
          title: v.$t("order"),
          searchable: false,
          data: (row) => {
            return `<span class="tag is-light">${row.sort_order || 0}</span>`;
          },
        },
        {
          title: v.$t("auto_assignment"),
          searchable: false,
          data: (row) => {
            const statusClass = row.auto_assignment_priority
              ? "is-success"
              : "is-light";
            const statusText = row.auto_assignment_priority
              ? v.$t("enabled")
              : v.$t("disabled");
            return `<span class="tag ${statusClass}">${statusText}</span>`;
          },
        },
        {
          title: v.$t("status"),
          searchable: false,
          data: (row) => {
            const statusClass = row.is_active ? "is-success" : "is-danger";
            const statusText = row.is_active
              ? v.$t("active")
              : v.$t("inactive");
            return `<span class="tag ${statusClass}">${statusText}</span>`;
          },
        },
        {
          title: v.$t("options"),
          searchable: false,
          data: (row) => {
            return generate_datatables_buttons([
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("edit"),
                icon: "fa fa-edit",
                icon_class: "is-small",
                click: function (e) {
                  v.$refs.priority_modal.show_modal(e.detail.uuid);
                },
              },
              {
                args: { uuid: row.uuid },
                tooltip: v.$t("delete"),
                icon: "fa fa-trash",
                icon_class: "is-small has-text-danger",
                click: (e) => {
                  let uuid = e.detail.uuid;
                  confirm_deletion_dialog(
                    v.$t("are_you_sure_delete"),
                    v,
                    () => {
                      del("/helpdesk/priority", { uuid: uuid })
                        .then(() => {
                          v.refresh();
                        })
                        .catch((error) => {
                          error_message(error);
                        });
                    }
                  );
                },
              },
            ]);
          },
        },
      ],
    };
  },
  methods: {
    create() {
      let v = this;
      v.$refs.priority_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    get_priority_icon(name) {
      if (!name) return "fa-flag";
      const lowerName = name.toLowerCase();
      if (
        lowerName.includes("alta") ||
        lowerName.includes("high") ||
        lowerName.includes("critica")
      ) {
        return "fa-exclamation-triangle";
      } else if (lowerName.includes("media") || lowerName.includes("medium")) {
        return "fa-flag";
      } else if (lowerName.includes("baja") || lowerName.includes("low")) {
        return "fa-flag-o";
      }
      return "fa-flag";
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
